import makeLookupModal from "../../UI/LookupModal/LookupModal";
import HighSchoolTranscriptTypeLookup from "./HighSchoolTranscriptTypeLookup";
const HighSchoolTranscriptTypeLookupModal = makeLookupModal(HighSchoolTranscriptTypeLookup, {
    pluralEntityName: "High School Transcript Types",
});
export default HighSchoolTranscriptTypeLookupModal;
